import axiosInstance, { getApiErrorMessage } from "../auth/apiConfig";
import {
  formatRoundTime,
  listAdmittedPatientsForDoctorRound,
  mapWebPatientToAdmissionRow,
  toApiTime,
} from "./doctorRoundService";

const WEB_BASE = "/api/v1/web/nursing-notes";

export {
  formatRoundTime,
  listAdmittedPatientsForDoctorRound,
  mapWebPatientToAdmissionRow,
  toApiTime,
};

export const searchNursingTemplates = async (query, top = 50) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/templates`, {
      params: { q: query?.trim() || undefined, top },
    });
    return response.data?.data ?? [];
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load templates"));
  }
};

export const searchNursingStaff = async (query, top = 50) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/staff`, {
      params: { q: query?.trim() || undefined, top },
    });
    return response.data?.data ?? [];
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load staff"));
  }
};

export const listNursingNotes = async (params) => {
  try {
    const response = await axiosInstance.get(WEB_BASE, {
      params: {
        admissionId: params.admissionId,
        fromDate: params.fromDate,
        toDate: params.toDate,
        notesById: params.notesById || undefined,
        isNursingNotes: params.isNursingNotes,
      },
    });
    return response.data?.data ?? [];
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load nursing notes"));
  }
};

export const getNursingNoteById = async (id) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/${id}`);
    return response.data?.data ?? null;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load nursing note"));
  }
};

export const createNursingNote = async (payload) => {
  try {
    const response = await axiosInstance.post(WEB_BASE, payload);
    return response.data?.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to save nursing note"));
  }
};

export const updateNursingNote = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`${WEB_BASE}/${id}`, payload);
    return response.data?.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to update nursing note"));
  }
};

export const toLookupOption = (item) => {
  if (!item) return null;
  const id = Number(item.id);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    id,
    value: id,
    label: item.name || `Item #${id}`,
    extra: item.extra || "",
  };
};

export const mapFormToSavePayload = (
  formData,
  patient,
  userId,
  isNursingNotes,
  { isUpdate } = {}
) => {
  const base = {
    date: formData.date,
    time: toApiTime(formData.time),
    templateId: Number(formData.templateName?.value ?? formData.templateName?.id),
    nursingRmoNotes: formData.notes || "",
    isNursingNotes: Boolean(isNursingNotes),
    staffId: Number(formData.staffName?.value ?? formData.staffName?.id),
  };

  if (isUpdate) {
    return {
      ...base,
      updatedById: userId,
    };
  }

  return {
    admissionId: Number(patient.admissionId),
    ...base,
    addedById: userId,
    updatedById: userId,
  };
};

export const mapRecordToFormValues = (row) => {
  if (!row) return null;
  return {
    date: row.date || new Date().toISOString().split("T")[0],
    time: formatRoundTime(row.time) || "",
    notes: row.nursingRmoNotes || "",
    templateName: toLookupOption({
      id: row.templateId,
      name: row.templateName,
    }),
    staffName: toLookupOption({
      id: row.notesById,
      name: row.notesByName,
    }),
  };
};

export const mapListRowForTable = (row, index) => ({
  id: row.nursingRmoNotesId,
  nursingRmoNotesId: row.nursingRmoNotesId,
  srNo: String(index + 1),
  date: row.date || "—",
  time: formatRoundTime(row.time) || "—",
  templateName: row.templateName || "—",
  notes: row.nursingRmoNotes || "",
  staffName: row.notesByName || "—",
  attachments: [],
});
